import type {ReactElement, ReactNode} from 'react';
import React from 'react';
import {Option} from '@Components/contextual-menu/components/option';
import {ImageThumbnailContainer} from '@Components/contextual-menu/components/image-thumbnail-container';
import type {IconSize} from "@Components/icon-v2/icon.types";
import {type IconShape, type IconType} from "@Components/icon-v2/icon.types";
import {Icon} from "@Components/icon-v2";

interface ContextualMenuImageThumbnailOptionProps {
  id: string;
  className?: string;
  label: string;
  imgSrc: string;

  onEdit(): void;

  isLoading?: boolean;
  optionTag?: ReactNode;
  thumbnailClass?: string;
  removeIconState?: RemoveIconState;
}

export interface RemoveIconState {
  icon: string;
  onClick: VoidFunction;
  iconSize?: IconSize;
  iconType?: IconType;
  iconShape?: IconShape;
  isSelected?: boolean;
  isDisabled?: boolean;
  className?: string;
}

export function ContextualMenuImageThumbnailOption({className = '', isLoading = false, thumbnailClass = '', ...props}: ContextualMenuImageThumbnailOptionProps): ReactElement<any> {
  const onClickEditIcon = (): void => {
    props.onEdit();
  };

  const getImageThumbnailContainer = (): ReactElement<any> => {
    return <ImageThumbnailContainer isLoading={isLoading} imgSrc={props.imgSrc} onEdit={onClickEditIcon} thumbnailClass={thumbnailClass} />;
  };

  const getRemoveCta = (removeIcon: RemoveIconState): ReactElement<any> => {
    return (
      <Icon
        icon={removeIcon.icon}
        type={removeIcon.iconType}
        shape={removeIcon.iconShape}
        size={removeIcon.iconSize}
        className={removeIcon.className}
        onClick={removeIcon.onClick}
      />
    );
  };

  const getOptionControl = (): ReactElement<any> => {
    if (!props.removeIconState) {
      return getImageThumbnailContainer();
    }

    return (
      <div className='flex-center'>
        {getRemoveCta(props.removeIconState)}
        {getImageThumbnailContainer()}
      </div>
    )
  };

  return (
    <Option
      key={props.id}
      label={props.label}
      tag={props.optionTag}
      className={className}
      optionControl={getOptionControl()}
    />
  );
}
